
<template>
    <TableHead class="j-sortable-head-root">
        <button
            class="j-orderable-column j-enabled"
            @click="toggleOrder"
        >
            <div><slot /></div>

            <fa-icon
                v-if="currentDir === 'ASC'"
                icon="fa-sort-up"
                class="j-order-icon asc"
            />
            <fa-icon
                v-else-if="currentDir === 'DESC'"
                icon="fa-sort-down"
                class="j-order-icon desc"
            />
        </button>
    </TableHead>
</template>

<script setup>
import { computed } from 'vue'

import TableHead from './TableHead.vue'

const props = defineProps({
    columnName: {
        type    : String,
        required: true,
    },
    modelValue: {
        type    : Object,
        default : () => ({ column: null, dir: null }),
    },
})

const emit = defineEmits(['update:modelValue'])

const currentDir = computed(() => {
    return props.modelValue.column === props.columnName
        ? props.modelValue.order
        : null
})

const toggleOrder = () => {
    let newDir = 'ASC'

    if (props.modelValue.column === props.columnName) {
        if (props.modelValue.order === 'ASC') {
            newDir = 'DESC'
        } else if (props.modelValue.order === 'DESC') {
            newDir = 'ASC'
        }
    }

    const newOrder = newDir
        ? { column: props.columnName, order: newDir }
        : { column: null, order: null }

    emit('update:modelValue', newOrder)
}
</script>